interface Props {
  [key: string]: any
}

function EmailGradientSupportIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 13 10" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M1 2.82788L5.80732 6.03276C6.00757 6.16636 6.2429 6.23766 6.48363 6.23766C6.72436 6.23766 6.95969 6.16636 7.15994 6.03276L11.9673 2.82788H1ZM2.21858 9.53009H10.7487C11.0719 9.53009 11.3818 9.40171 11.6103 9.17318C11.8389 8.94465 11.9673 8.6347 11.9673 8.31151V2.21858C11.9673 1.8954 11.8389 1.58544 11.6103 1.35692C11.3818 1.12839 11.0719 1 10.7487 1H2.21858C1.8954 1 1.58544 1.12839 1.35692 1.35692C1.12839 1.58544 1 1.8954 1 2.21858V8.31151C1 8.6347 1.12839 8.94465 1.35692 9.17318C1.58544 9.40171 1.8954 9.53009 2.21858 9.53009Z"
        stroke="url(#linear_email_support)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.860178"
      />
      <defs className={pathClassName ? `stroke-current ${pathClassName}` : ''}>
        <linearGradient gradientTransform="rotate(21.67)" id="linear_email_support">
          <stop offset="25.12%" stopColor="#7D38D6" />
          <stop offset="100%" stopColor="#58C1FC" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default EmailGradientSupportIcon
